import { ComponentType } from "react";
import styles from "./roster-statistic-card.module.css";
import { RosterIconProps } from "./roster-icons";
import { Skeleton } from "@mui/material";

type RosterStatisticCardProps = {
	Icon: ComponentType<RosterIconProps>;
	title: string;
	count?: number;
	color: string;
};

const GradientBackground = ({ color }: { color: string }) => {
	return (
		<div
			style={{
				background: `radial-gradient(circle at top left, ${color}25, transparent 40%)`,
				position: "absolute",
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
			}}
		/>
	);
};

export function RosterStatisticCard({ Icon, title, count, color }: RosterStatisticCardProps) {
	return (
		<div className={styles.container}>
			<GradientBackground color={color} />

			<div className={styles.header}>
				<Icon className={styles.icon} svgcolors={{ stroke: color, fill: color }} />
			</div>

			<div className={styles.body}>
				<div className={styles.title}>{title}</div>
				{count === undefined ? (
					<Skeleton className={styles.countSkeleton} />
				) : (
					<div className={styles.count}>{count}</div>
				)}
			</div>
		</div>
	);
}
